/**
 * return button
 * @requires:
 * html content: returnButton.mod
 */
import returnButtonContent from '../../html/content_module/returnButton.mod';

var returnButton = $(returnButtonContent);
returnButton.addClass('floatingPosition').appendTo(document.body);

var returnButtonHelper = {

    el : returnButton,
    setAction : function(func){
        $(this.el).on('click', func);
    }
};

export default returnButtonHelper;




/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/content_module/returnButton.js
 **/